import React from "react";
import AIPortfolio from "./components/AiPortfolio";

function App() {
  return <AIPortfolio />;
}

export default App;


// import React from 'react';
// import './App.css';
// import Header from './components/Header/Header.js';
// import Footer from './components/Footer/Footer.js';
// import ProjectHolder from './components/ProjectHolder/ProjectHolder.js';
// import Skills from './components/Skills/Skills.js';

// function App() {
//   return (
//     <div className="App">
//       <h1>Garrett Troyer's React Portfolio!</h1>
//       <Header />
//       <h2>Skills</h2>
//       <Skills />

//       <h2>About Me...</h2>
//       <h4>
//         I am a recent coding boot camp graduate, as of June 2020. 
//         <br></br>I also obtained an A.A.S. in Computer Programming from San Antonio College in 2018.
//         <br></br>I am passionate about Biology and Computer Science - and where the two meet. Wetware, Biotechnology, Bioinformatics and Cyborgism/Cybernetics all pertain heavily to my interests.
//         <br></br>It has pained me to witness a friend suffer from schizophrenia, and a dear Uncle pass away prematurely from cancer.
//         <br></br>So one day in the future, I aim to help bridge the gap between our bodies and technology as much as possible with other people who have similar intent. 
//         <br></br>For now, making websites is a pretty neat trick (o:
//         <br></br>The buttons beneath each project are links to README's.
//         <br></br>If the gif image of the project being used bothers you on a mobile device, simply tap in the project somewhere to hide it.</h4>
        
//       <ProjectHolder />
//       <canvas id="canvas"></canvas>
//       <canvas id="myCanvas"></canvas>
//       <Footer />
      
//     </div>
//   );
// }

// export default App;
